"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.join = exports.subst = exports.query = void 0;
function urlcat(baseUrlOrTemplate, pathTemplateOrParams, maybeParams) {
    if (maybeParams === void 0) { maybeParams = {}; }
    if (typeof pathTemplateOrParams === 'string') {
        var baseUrl = baseUrlOrTemplate;
        var pathTemplate = pathTemplateOrParams;
        var params = maybeParams;
        return urlcatImpl(pathTemplate, params, baseUrl);
    }
    else {
        var baseTemplate = baseUrlOrTemplate;
        var params = pathTemplateOrParams;
        return urlcatImpl(baseTemplate, params);
    }
}
exports.default = urlcat;
function urlcatImpl(pathTemplate, params, baseUrl) {
    var cleanParams = removeNullOrUndef(params);
    var _a = path(pathTemplate, cleanParams), renderedPath = _a.renderedPath, remainingParams = _a.remainingParams;
    var renderedQuery = query(remainingParams);
    var pathAndQuery = join(renderedPath, '?', renderedQuery);
    return baseUrl
        ? join(baseUrl, '/', pathAndQuery)
        : pathAndQuery;
}
function query(params) {
    return new URLSearchParams(params).toString();
}
exports.query = query;
function subst(template, params) {
    var renderedPath = path(template, params).renderedPath;
    return renderedPath;
}
exports.subst = subst;
function path(template, params) {
    var remainingParams = __assign({}, params);
    var renderedPath = template.replace(/:\w+/g, function (p) {
        var key = p.slice(1);
        if (!params.hasOwnProperty(key)) {
            return p;
        }
        delete remainingParams[key];
        return encodeURIComponent(params[key]);
    });
    return { renderedPath: renderedPath, remainingParams: remainingParams };
}
function join(part1, separator, part2) {
    var p1 = part1.endsWith(separator) ? part1.slice(0, -separator.length) : part1;
    var p2 = part2.startsWith(separator) ? part2.slice(separator.length) : part2;
    return p1 === '' || p2 === ''
        ? p1 + p2
        : p1 + separator + p2;
}
exports.join = join;
function removeNullOrUndef(params) {
    return Object.keys(params)
        .filter(function (k) { return notNullOrUndefined(params[k]); })
        .reduce(function (result, k) {
        result[k] = params[k];
        return result;
    }, {});
}
function notNullOrUndefined(v) {
    return v !== undefined && v !== null;
}
